module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Black_MockedUp.b2d4fea1.jpg";